if (!customElements.get('collapsible-tabs')) {
  customElements.define(
    'collapsible-tabs',
    class CollapsibleTabs extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.detailsElements = this.querySelectorAll('.accordion-details');
        this.colorScheme = this.dataset.colorScheme;

        // Always add color scheme class to all accordion-card items
        this.detailsElements.forEach((details) => {
          const parent = details.closest('.accordion-item');
          if (parent && parent.classList.contains('accordion-card')) {
            parent.classList.add(this.colorScheme);
          }
        });

        this.detailsElements.length > 0 &&
          this.detailsElements.forEach((details) => {
            details.open ? this.handleOpen(details) : this.handleClose(details);
            details.addEventListener('toggle', this.onToggle.bind(this));
          });
      }

      onToggle(event) {
        const activeDetails = event.target;
        if (activeDetails.open) {
          this.handleOpen(activeDetails);
        } else {
          this.handleClose(activeDetails);
        }
      }

      handleOpen(details) {
        // No-op: color scheme class is always present
      }

      handleClose(details) {
        // No-op: color scheme class is always present
      }
    }
  );
}
